import { render, staticRenderFns } from "./SubmissionDetail.vue?vue&type=template&id=43bae1df&scoped=true&"
import script from "./SubmissionDetail.vue?vue&type=script&lang=js&"
export * from "./SubmissionDetail.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionDetail.vue?vue&type=style&index=0&id=43bae1df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bae1df",
  null
  
)

export default component.exports